import React, { useState } from 'react';
// Assuming FAQ component is in '../components/FAQ'
// import FAQ from '../components/FAQ';

// Mock FAQ component if not provided, remove this if you have the file
const FAQ = ({ title }) => (
  <section className="faq-section bg-gray-100 p-8 rounded-lg mt-12">
    <h2 className="text-2xl font-bold mb-4">{title}</h2>
    <div className="space-y-4">
      <div>
        <h4 className="font-semibold">What is this site for?</h4>
        <p>This is a placeholder answer for the FAQ section.</p>
      </div>
      <div>
        <h4 className="font-semibold">How do I contact support?</h4>
        <p>You can use the form on this page or join our Discord server.</p>
      </div>
    </div>
  </section>
);


const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  // --- FIX ---
  // Define isSubmitting and submitMessage using useState
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  // --- END FIX ---

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage(''); // Clear any previous messages

    try {
      const mailtoLink = `mailto:factsonly9667@gmail.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`)}`;
      
      // --- FIX ---
      // Use setSubmitMessage instead of alert()
      setSubmitMessage('Opening your email client... Please send the email to complete your message.');
      // --- END FIX ---

      // Open the mail client
      window.location.href = mailtoLink;
      
      // Reset form fields
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });

    } catch (error) {
      console.error("Failed to create mailto link:", error);
      setSubmitMessage('An error occurred. Please try again or email us directly.');
    } finally {
      // Set submitting back to false after a short delay
      // to allow the message to be seen before potential redirect
      setTimeout(() => {
        setIsSubmitting(false);
      }, 1000);
    }
  };

  // Basic styling for demonstration if no CSS is present
  // You can remove this <style> block if you have your own stylesheet
  const GlobalStyles = () => (
    <style>{`
      .contact-page {
        font-family: 'Inter', sans-serif;
        max-width: 1200px;
        margin: 0 auto;
        padding: 2rem;
        color: #333;
      }
      .contact {
        background: #ffffff;
        border-radius: 12px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
        overflow: hidden;
      }
      .contact-container {
        padding: 2rem 2.5rem;
      }
      .contact-container h2 {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 0.5rem;
        color: #111;
      }
      .contact-intro {
        font-size: 1.1rem;
        color: #555;
        margin-bottom: 2rem;
      }
      .contact-form .form-group {
        margin-bottom: 1.25rem;
      }
      .contact-form label {
        display: block;
        font-weight: 600;
        margin-bottom: 0.5rem;
        font-size: 0.9rem;
      }
      .contact-form input,
      .contact-form textarea {
        width: 100%;
        padding: 0.85rem 1rem;
        border: 1px solid #ddd;
        border-radius: 8px;
        font-size: 1rem;
        transition: border-color 0.2s, box-shadow 0.2s;
      }
      .contact-form input:focus,
      .contact-form textarea:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
      }
      .contact-form textarea {
        min-height: 140px;
        resize: vertical;
      }
      .submit-btn {
        width: 100%;
        padding: 0.9rem;
        border: none;
        border-radius: 8px;
        background-color: #3b82f6;
        color: white;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s;
      }
      .submit-btn:hover {
        background-color: #2563eb;
      }
      .submit-btn:disabled {
        background-color: #9ca3af;
        cursor: not-allowed;
      }
      .submit-message {
        text-align: center;
        margin-top: 1rem;
        font-weight: 500;
        padding: 0.75rem;
        border-radius: 8px;
      }
      .submit-message.success {
        background-color: #d1fae5;
        color: #065f46;
      }
      .submit-message.error {
        background-color: #fee2e2;
        color: #991b1b;
      }
      .contact-info {
        margin-top: 2.5rem;
        border-top: 1px solid #eee;
        padding-top: 2rem;
      }
      .contact-info h3 {
        font-size: 1.5rem;
        font-weight: 600;
        margin-bottom: 1rem;
      }
      .contact-item {
        margin-bottom: 0.75rem;
        color: #333;
      }
      .contact-item a {
        color: #3b82f6;
        text-decoration: none;
        font-weight: 500;
      }
      .contact-item a:hover {
        text-decoration: underline;
      }
      /* Simple responsive */
      @media (min-width: 768px) {
        .contact-container {
          padding: 3rem 4rem;
        }
      }
    `}</style>
  );

  return (
    <>
      <GlobalStyles />
      <div className="contact-page">
        <section className="contact">
          <div className="contact-container">
            <h2>Get In Touch</h2>
            <p className="contact-intro">Have questions or suggestions? We'd love to hear from you!</p>
            
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  value={formData.name}
                  onChange={handleChange}
                  required 
                  placeholder="Your name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleChange}
                  required 
                  placeholder="your.email@example.com"
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input 
                  type="text" 
                  id="subject" 
                  name="subject" 
                  value={formData.subject}
                  onChange={handleChange}
                  required 
                  placeholder="What is this about?"
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea 
                  id="message" 
                  name="message" 
                  value={formData.message}
                  onChange={handleChange}
                  required 
                  placeholder="Your message here..."
                />
              </div>
              <button type="submit" className="submit-btn" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
              {submitMessage && (
                // --- FIX ---
                // Determine class based on message content
                <p className={`submit-message ${submitMessage.includes('error') ? 'error' : 'success'}`}>
                  {submitMessage}
                </p>
                // --- END FIX ---
              )}
            </form>

            <div className="contact-info">
              <h3>Other Ways to Reach Us</h3>
              <div className="contact-item">
                <strong>Email:</strong> <a href="mailto:factsonly9667@gmail.com">factsonly9667@gmail.com</a>
              </div>
              <div className="contact-item">
                <strong>Discord Support:</strong> <a href="https://discord.gg/5tUh6aktZw" target="_blank" rel="noopener noreferrer">Join our server</a>
              </div>
            </div>
          </div>
        </section>

        <FAQ title="Frequently Asked Questions" />
      </div>
    </>
  );
};

export default Contact;
